import { render, staticRenderFns } from "./PrivateOnlineSessionEdit.vue?vue&type=template&id=615e6516&scoped=true&"
import script from "./PrivateOnlineSessionEdit.vue?vue&type=script&lang=js&"
export * from "./PrivateOnlineSessionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615e6516",
  null
  
)

export default component.exports